import getImage from 'library/helpers/get-thumbnail-image-source';
import { useState } from 'react';
import MissingThumbImage from 'assets/images/missing-thumbnail.jpg';
import { Image } from './styles';

const ImageComponent = ({
  source,
  id,
  name,
  width,
  height,
  isNew = false,
  isCover = false,
  isThumb = true,
  imgRef,
  isLoaded = true,
}) => {
  const [src, setSrc] = useState(getImage(source, isThumb));

  return (
    <Image
      key={id}
      ref={imgRef}
      isCover={isCover}
      alt={isNew ? '' : name}
      width={width}
      height={!isLoaded ? height : undefined}
      src={src}
      isLoaded={isLoaded || height > 0}
      onError={() => {
        setSrc(MissingThumbImage);
      }}
    />
  );
};

export default ImageComponent;
